export const buildRootCauseChartData = (candidates) => ({
    labels: candidates.map((item) => `Step ${item.relatedStep}`),
    datasets: [
        {
            label: 'Root cause evidence score',
            data: candidates.map((item) => Number(item.rootCauseScore ?? item.probability) || 0),
            backgroundColor: 'rgba(214, 69, 69, 0.72)',
            borderColor: '#d64545',
            borderWidth: 1,
        },
    ],
});

export const rootCauseChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { position: 'bottom' },
    },
    scales: {
        y: {
            beginAtZero: true,
            max: 100,
            title: { display: true, text: 'Evidence score' },
        },
    },
};

export const groupByProbability = (candidates) => candidates.reduce((acc, analysis) => {
    const probability = String(Math.round(Number(analysis.rootCauseScore ?? analysis.probability) || 0));
    if (!acc[probability]) acc[probability] = [];
    acc[probability].push(analysis);
    return acc;
}, {});

export const getRootCauseMetrics = (candidates, summary = {}) => {
    const scoreOf = (item) => Number(item.rootCauseScore ?? item.probability) || 0;
    const maxScore = candidates.length
        ? Math.max(...candidates.map(scoreOf))
        : 0;
    const likelySteps = candidates.filter((item) => scoreOf(item) >= 70).length;
    const topStep = candidates.length
        ? [...candidates].sort((a, b) => scoreOf(b) - scoreOf(a))[0]
        : null;

    return [
        { label: 'Target failures', value: summary.caseSessions ?? 0, tone: 'fail' },
        { label: 'Control sessions', value: summary.controlSessions ?? 0, tone: 'neutral' },
        { label: 'Candidates', value: candidates.length, tone: 'neutral' },
        { label: 'Highest score', value: maxScore.toFixed(1), tone: 'fail' },
        { label: 'Strong candidates', value: likelySteps, tone: 'fail' },
        { label: 'Top candidate', value: topStep ? `Step ${topStep.relatedStep}` : '-', tone: 'neutral' },
    ];
};
